import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClock, /*faFolderOpen*/ } from "@fortawesome/free-regular-svg-icons"
import { faChevronLeft, faChevronRight, /*faAnchor*/ } from "@fortawesome/free-solid-svg-icons"

//import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
//import { BLOCKS } from "@contentful/rich-text-types"
//import useContentfulImage from "../utils/useContentfulImage"
//import useContentfulEmbed from "../utils/useContentfulEmbed"
//import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer"

import marked from "marked"

import SEO from "../components/seo"
import Iframely from "../components/iframely"

import SharingButtons from '../components/sharingButtons';
import "../components/prismjs/themes/prism-tomorrow.css";

// import { 
//     FacebookShareButton, 
//     FacebookIcon, 
//     FacebookShareCount,
//     LineShareButton, 
//     LineIcon,
//     TwitterShareButton,
//     TwitterIcon,
//     PocketShareButton,
//     PocketIcon
//   } from 'react-share';

// SNSシェアボタンセクション
// title : 記事タイトル
// articleUrl : 記事URL
// const SNSSection = ({title , articleUrl}) => {
//     return (
//       <div>
//         <FacebookShareButton url={articleUrl}>
//           <FacebookIcon size={50} borderRadius={5} />
//         </FacebookShareButton>
  
//         <LineShareButton url={articleUrl} >
//           <LineIcon size={50} borderRadius={5} />
//         </LineShareButton>
    
//       </div>
//     )
//   }


// const options = {
//     renderNode: {
//       [ BLOCKS.HEADING_2 ]: (node, children) => (
//           <h2>
//               <FontAwesomeIcon icon={faAnchor} />
//               {children}
//           </h2>
//       ),
//       [ BLOCKS.EMBEDDED_ASSET ]: node => (
//           <Img
//             fluid={useContentfulImage(node.data.target.fields.file["ja-JP"].url)}
//             alt={
//                 node.data.target.fields.description
//                   ? node.data.target.fields.description["ja-JP"]
//                   : node.data.target.fields.title["ja-JP"]
//             }
//           />
//       )
//     },
//     renderText: text => {
//         return text.split("\n").reduce((children, textSegment, index) => {
//             return [...children, index > 0 && <br key={index} />, textSegment]
//         },[])
//     },
// }



export default ({ data, pageContext, location }) => {

    const source = data.contentfulBlogPost.content2.childMarkdownRemark.html.replace(/\n/gi, '\nreplaced_text ');
  marked.setOptions({
    gfm: true,
    breaks: true,
  });
  const parsedSouce = marked(source).replace(/replaced_text/g, '');


    return (
    
    <Layout>
        <SEO
            pagetitle={data.contentfulBlogPost.title}
            pagedesc={data.contentfulBlogPost.firstdec}
            pagepath={location.pathname}
            blogimg={`https:${data.contentfulBlogPost.eyecatch.file.url}`}
            pageimgw={data.contentfulBlogPost.eyecatch.file.details.image.width}
            pageimgh={data.contentfulBlogPost.eyecatch.file.details.image.height}
        />
        <Iframely />
        <section className="container-bkg">
            <div className="eyecatch">
                <figure>
                <Img
                    fluid={data.contentfulBlogPost.eyecatch.fluid}
                    alt={data.contentfulBlogPost.eyecatch.description}
                />
                </figure>
            </div>
            <article className="content">
                <div className="container">
                <h1 className="bar">{data.contentfulBlogPost.title}</h1>
                <aside className="info">
                    <div className="cat">
                        <ul className="post-footer">
                            {data.contentfulBlogPost.category.map(cat => (
                                <li className={`newmo-sm category ${cat.categorySlug}`} key={cat.id}>
                                    <Link to={`/cat/${cat.categorySlug}/`}>{cat.category}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <time dateTime={data.contentfulBlogPost.publishDate}><FontAwesomeIcon icon={faClock} />
                    {data.contentfulBlogPost.publishDateJP}
                    </time>
                </aside>
                <aside className="twitter">
                <SharingButtons
                    title={data.contentfulBlogPost.title}
                    url={`${data.site.siteMetadata.siteUrl}${location.pathname}`}
                />
                    {/* <FontAwesomeIcon icon={faTwitter} /> */}
                </aside>
                

                <div className="postbody" dangerouslySetInnerHTML={{ __html: marked(parsedSouce) }} />


                <aside className="twitter">
                    <div className="bmc newmo-sm">
                        コーヒー1杯分の優しさ
                        <a className="" href="https://www.buymeacoffee.com/tyler0702" rel="noreferrer" target="_blank">
                            <Img 
                                fluid={data.bmc.childImageSharp.fluid}
                                alt="Buy Me A Coffee" 
                                style={{height: '60px !important', width: '217px !important'}} 
                                />
                        </a>
                    </div>
                <SharingButtons
                    title={data.contentfulBlogPost.title}
                    url={`${data.site.siteMetadata.siteUrl}${location.pathname}`}
                />
                    {/* <FontAwesomeIcon icon={faTwitter} /> */}
                </aside>

                <ul className="postlink">
                    {pageContext.next && (
                        <li className="prev">
                            <Link to={`/blog/post/${pageContext.next.slug}/`} rel="prev">
                            <FontAwesomeIcon icon={faChevronLeft} />
                            <span>{pageContext.next.title}</span>
                            </Link>
                        </li>
                    )}
                    {pageContext.previous && (
                        <li className="next">
                            <Link to={`/blog/post/${pageContext.previous.slug}/`} rel="next">
                            <span>{pageContext.previous.title}</span>
                            <FontAwesomeIcon icon={faChevronRight} />
                            </Link>
                        </li>
                    )}
                </ul>
                </div>
            </article>
        </section>                    
    </Layout>
)
                    }

export const query = graphql`
    query($id: String!) {
        contentfulBlogPost(id: { eq: $id }) {
            title
            firstdec
            publishDateJP:publishDate(formatString: "YYYY年MM月DD日")
            publishDate
            category {
                category
                categorySlug
                id
            }
            eyecatch {
                fluid(maxWidth: 1600) {
                    ...GatsbyContentfulFluid_withWebp
                }
                description
                file {
                    details {
                      image {
                        width
                        height
                      }
                    }
                    url
                  }
            }
            content {
                json
            }
            content2 {
                childMarkdownRemark{
                    html
                }
            }
        }
        site {
            siteMetadata {
                siteUrl
            }
        }
        bmc: file(relativePath: {eq: "bmc.png"}) {
            childImageSharp {
              fluid(maxWidth: 217) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
              }
            }
          }
    }
`